const glow = ({ theme: { colors }, $glowColor, $noGlow, $glowWidth = 1 }) => {
  if ($noGlow) return "box-shadow 0 0 0 0 #ffffff;";
  return `box-shadow: 0 0 0 ${$glowWidth}px ${
    colors[$glowColor] || $glowColor || colors.fnBlue
  }b5;`;
};

export default glow;
